import React from 'react';

import { QueryContainer } from '@components/QueryContainer';
import { BookingCreateForm } from '@components/utilities/BookingInquiry/BookingCreateForm';
import { useCompany } from '@hooks/queries/useCompany';
import { useUser } from '@hooks/queries/useUser';

export const InquiryForm: React.FC = () => {
  const user = useUser();
  const company = useCompany();

  return (
    <QueryContainer queries={[user, company]}>
      {() => (
        <BookingCreateForm
          ownerId={user.data!.id}
          ownerCompanyId={company.data!.id}
          ownerCompanyCountry={company.data!.country}
        />
      )}
    </QueryContainer>
  );
};
